import { render, staticRenderFns } from "./server-list.vue?vue&type=template&id=55d96833&lang=pug&"
import script from "./server-list.vue?vue&type=script&lang=js&"
export * from "./server-list.vue?vue&type=script&lang=js&"
import style0 from "./server-list.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports